import React from 'react';

import { BaseballCard } from '@minecraft.molecules';
import { TalentScoutProfileFragment } from '@minecraft.graphql-operations';
import { useTranslation } from '@blocs.i18n';

type ResumeIconProps = Pick<TalentScoutProfileFragment, 'profileId' | 'hasResume'>;
const ResumeIcon = ({ hasResume, profileId }: ResumeIconProps) => {
  const { t } = useTranslation();

  return (
    <BaseballCard.Icon
      data-testid="resume-icon"
      id={`IconResume-${profileId}`}
      isActive={hasResume}
      link={`/profile/${profileId}/preview`}
      name="resume"
      size="1.25rem"
      aria-label={t('common:label.pdfResume')}
      tooltip={t('common:label.pdfResume')}
    />
  );
};

type ReelIconProps = Pick<TalentScoutProfileFragment, 'profileId' | 'hasAudioReel' | 'hasVideoReel'>;
const ReelIcon = ({ hasAudioReel, hasVideoReel, profileId }: ReelIconProps) => {
  const { t } = useTranslation();

  return (
    <BaseballCard.Icon
      data-testid="reel-icon"
      id={`IconReel-${profileId}`}
      isActive={hasAudioReel || hasVideoReel}
      link={`/profile/${profileId}/preview`}
      name="reel"
      size="1.25rem"
      aria-label={t('common:profile.reels')}
      tooltip={
        <>
          {hasAudioReel && <div>{t('common:mediaType.audioItem')}</div>}
          {hasVideoReel && <div>{t('common:mediaType.videoItem')}</div>}
        </>
      }
    />
  );
};

type SpiceRackProps = Pick<TalentScoutProfileFragment, 'profileId' | 'hasAudioReel' | 'hasResume' | 'hasVideoReel'>;

export const SpiceRack = ({ profileId, hasAudioReel, hasVideoReel, hasResume }: SpiceRackProps) => {
  return (
    <BaseballCard.Section backgroundColor="listItem" flexDirection="row" gap="2" size="small" grow={0}>
      <ResumeIcon profileId={profileId} hasResume={hasResume} />
      <ReelIcon profileId={profileId} hasAudioReel={hasAudioReel} hasVideoReel={hasVideoReel} />
    </BaseballCard.Section>
  );
};
